import { useState, type ReactNode } from 'react';
import { FloatingPanelChrome } from './FloatingPanelChrome.tsx';
import {
  SHEET_PANEL_BOUNDS,
  commitSheetPanelGeometry,
  readSheetPanelPrefs,
  requestSheetPanelClose,
  requestSheetPanelMoveBy,
  resizeSheetPanel,
} from '../obr/sheetPanel.ts';

export function SheetWindowFrame({ floating, children }: { floating: boolean; children: ReactNode }) {
  const [geometry, setGeometry] = useState(() => readSheetPanelPrefs());
  return (
    <FloatingPanelChrome
      title="DCC Crawler Sheets"
      geometry={geometry}
      bounds={SHEET_PANEL_BOUNDS}
      onLiveResize={async (width, height) => setGeometry(await resizeSheetPanel(width, height, floating))}
      onCommitGeometry={async (next) => setGeometry(await commitSheetPanelGeometry(next, floating))}
      onMoveBy={async (dx, dy) => setGeometry(await requestSheetPanelMoveBy(dx, dy, floating))}
      onClose={() => requestSheetPanelClose(floating)}
    >
      {children}
    </FloatingPanelChrome>
  );
}
